import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Typography } from 'antd'

//style
import './index.css'
import typo from "../../constants/dictionaries";

const { Title } = Typography;

// Components
const DACTList = lazy(() => import('./DeAnChiTiet/list'));
const DACTDetail = lazy(() => import('./DeAnChiTiet/detail'));
const DACTForm = lazy(() => import('./DeAnChiTiet/form'));

const BaoCaoDinhKy = lazy(() => import('./BaoCaoDinhKy'))

const TramQuanTrac = lazy(() => import('./TramQuanTrac'))

export default ({ match }) => {
  const DACT = 'de-an-chi-tiet'
  const BCDK = 'bao-cao-dinh-ky'
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/de-an-chi-tiet`} component={DACTList} />
        <Route path={`${match.path}/de-an-chi-tiet/add`} render={() => <DACTForm />} />
        <Route path={`${match.path}/de-an-chi-tiet/edit/:id`} render={() => <DACTForm />} />
        <Route path={`${match.path}/de-an-chi-tiet/:id`} component={DACTDetail} />
        <Route exact path={`${match.path}/${BCDK}`} component={BaoCaoDinhKy} />
        <Route exact path={`${match.path}/tram-quan-trac`} component={TramQuanTrac} />
      </Switch>
    </Suspense>
  )
}